import React, { useEffect } from 'react';
import ChatGPTLayout from './ChatGPTLayout';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useIsAuthenticated } from './useIsAuthenticated';
import axios from 'axios';
import LogoutButton from './components/LogoutButton';
import LoginScreen from './LoginScreen';

import { BACKEND_ENDPOINT, CLIENTID } from './config/authConfig';

function App() {
  const { user, checking } = useIsAuthenticated();

  const handleLoginSuccess = async (credentialResponse) => {
    const token = credentialResponse.credential;
    try {
      await axios.post(
        `${BACKEND_ENDPOINT}/auth/login`,
        { token },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      window.location.reload(); // or trigger re-auth
    } catch (err) {
      console.error('Login failed', err);
    }
  };

  useEffect(() => {
    if (!user) {
      window.google?.accounts?.id?.initialize({
        client_id: CLIENTID,
        callback: handleLoginSuccess,
      });
      window.google?.accounts?.id?.prompt();
    }
  }, [user]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.response?.status === 401) {
          console.warn("Session expired. Redirecting to login...");
          window.location.href = "/";
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  if (checking) return <p>Checking authentication...</p>;

  return (
    <GoogleOAuthProvider clientId={CLIENTID}>
      {user ? (
        <div> 
          <p>Welcome, {user.email} ({user.user_id})</p>
          <LogoutButton />
          <ChatGPTLayout />
        </div>
      ) : (
        <LoginScreen onLoginSuccess={handleLoginSuccess} />
      )}
    </GoogleOAuthProvider>
  );
}

export default App;
